<template>
    <div class="app-container">
        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    v-hasPermi="['fang:lunbo:add']"
                >新增</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    v-hasPermi="['fang:lunbo:edit']"
                >修改</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    v-hasPermi="['fang:lunbo:remove']"
                >删除</el-button>
            </el-col>
            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>

        <el-table v-loading="loading" :data="lunboList" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="轮播图" align="center" prop="imgPath" width="100">
                <template slot-scope="scope">
                    <image-preview :src="scope.row.imgPath" :width="50" :height="50"/>
                </template>
            </el-table-column>
            <el-table-column label="顺序" align="center" prop="imgOrder" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"
                        v-hasPermi="['fang:lunbo:edit']"
                    >修改</el-button>
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"
                        v-hasPermi="['fang:lunbo:remove']"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改首页轮播图对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="轮播图" prop="imgPath">
                    <image-upload limit="1" v-model="form.imgPath"/>
                </el-form-item>
                <el-form-item label="顺序" prop="imgOrder">
                    <el-input v-model="form.imgOrder" placeholder="请输入顺序" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listLunbo, getLunbo, delLunbo, addLunbo, updateLunbo } from "@/api/homestay/api";

export default {
    name: "Lunbo",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 首页轮播图表格数据
            lunboList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                imgPath: null,
                imgOrder: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    { required: true, message: "$comment不能为空", trigger: "blur" }
                ],
                imgPath: [
                    { required: true, message: "图片路径不能为空", trigger: "blur" }
                ],
                imgOrder: [
                    { required: true, message: "顺序不能为空", trigger: "blur" }
                ],
                delFlag: [
                    { required: true, message: "删除标志不能为空", trigger: "blur" }
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询首页轮播图列表 */
        getList() {
            this.loading = true;
            listLunbo(this.queryParams).then(response => {
                this.lunboList =response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                imgPath: null,
                imgOrder: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length!==1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加首页轮播图";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const ids = row.id || this.ids.join(',')
            getLunbo({'id':ids}).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改首页轮播图";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateLunbo(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addLunbo(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除数据项？').then(function() {
                return delLunbo({'ids':idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {});
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('fang/lunbo/export', {
                ...this.queryParams
            }, `lunbo_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
